import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgModule } from '@shared/components/svg/svg.module';
import { OverlayModule } from '@angular/cdk/overlay';
import { SelectModule } from '@shared/components/select/select.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgLetModule } from '@shared/directives/ng-let/ng-let.module';
import { HoverableSvgModule } from '@shared/components/hoverable-svg/hoverable-svg.module';
import { NumericInputModule } from '@shared/components/numeric-input/numeric-input.module';
import { TranslateModule } from '@ngx-translate/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SearchFilterComponent } from './components/search-filter/search-filter.component';
import { NgxMaskDirective, provideEnvironmentNgxMask } from "ngx-mask";

@NgModule({
  declarations: [SearchFilterComponent],
  imports: [
    CommonModule,
    SvgModule,
    OverlayModule,
    SelectModule,
    FormsModule,
    NgLetModule,
    HoverableSvgModule,
    NumericInputModule,
    TranslateModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    MatTooltipModule,
    NgxMaskDirective
  ],
  exports: [SearchFilterComponent],
  providers: [provideEnvironmentNgxMask()]
})
export class FilterCatalogItemsModule {}
